import { render, staticRenderFns } from "./collectDetail.vue?vue&type=template&id=5e224494&scoped=true&"
import script from "./collectDetail.vue?vue&type=script&lang=js&"
export * from "./collectDetail.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./collectDetail.vue?vue&type=style&index=0&id=5e224494&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5e224494",
  "d83d515e"
  
)

export default component.exports